// extracted by mini-css-extract-plugin
export var cons = "cons";
export var pros = "pros";
export var root = "jRs5";
export var rootArrow = "O2Y6";
export var rootContent = "hNKH";
export var rootSummary = "reA+";
export var table = "table";
export var tableWrapper = "tableWrapper";